import React, { useEffect, useState } from 'react'
import { Modal, Table } from 'antd'
import apiService from '../../apiService'
import { processResponse } from '../../../../systems/api'
import { SafeImage } from '../../../common/components/Image'

export default function PackageItemIssuesModal({ visible, onClose, orderId, packageCode }) {
    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(false)
    const [previewImage, setPreviewImage] = useState(null)

    useEffect(() => {
        if (visible && packageCode) {
            fetchProducts()
        }
    }, [visible, packageCode])


    function fetchProducts() {

        setLoading(true)
        let res = apiService.getPackageItemIssues(orderId)
        processResponse(res)
            .then(res => {

                const items = res.data.package_items_issues || []

                const matched = items.find(p => p.package.code === packageCode)
                const issueItems = matched && matched.issue_items ? matched.issue_items : []

                setProducts(issueItems)
            })
            .catch(() => {})
            .finally(() => setLoading(false))
    }

    const columns = [
        {
            title: 'Mã sản phẩm',
            dataIndex: ['order_item', 'code_item'],
            key: 'code_item',
        },
        {
            title: 'Loại lỗi',
            dataIndex: 'issue_type',
            key: 'issue_type',
            render: (type, record) => {
                const nameVi = record.issue_type_name
                const nameZh = record.issue_type_name_zh

                if (!nameVi && !nameZh) {
                    return type
                }
                return (
                    <div>
                        {nameVi && <div>{nameVi}</div>}
                        {nameZh && <div style={{ color: '#999', fontSize: '12px' }}>{nameZh}</div>}
                    </div>
                )
            }
        },
        {
            title: 'Số lượng',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: 'Hình ảnh lỗi',
            dataIndex: 'image_urls',
            key: 'image_urls',
            render: (images = []) => (
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                    {images.map((url, i) => (
                        <SafeImage
                            key={i}
                            src={url}
                            width={60}
                            height={60}
                            style={{
                                objectFit: 'cover',
                                borderRadius: 4,
                                border: '1px solid #eee',
                                cursor: 'pointer'
                            }}
                            onClick={() => setPreviewImage(url)}
                            alt={`issue-${i}`}
                        />
                    ))}
                </div>
            )
        },
        {
            title: 'Ghi chú',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                const mapping = {
                    pending: 'Chờ xử lý',
                    resolved: 'Đã xử lý',
                    rejected: 'Từ chối',
                }
                return mapping[status] || status
            }
        },
    ]

    return (
        <Modal
            title={`Sản phẩm sai lỗi của kiện ${packageCode}`}
            visible={visible}
            onCancel={onClose}
            footer={null}
            width={900}
        >
            <Table
                dataSource={products}
                columns={columns}
                rowKey="id"
                loading={loading}
                pagination={false}
            />
            {previewImage && (
                <Modal
                    visible={true}
                    footer={null}
                    onCancel={() => setPreviewImage(null)}
                    width="auto"
                    style={{ textAlign: 'center' }}
                    bodyStyle={{ padding: 0 }}
                >
                    <img
                        src={previewImage}
                        alt="Preview"
                        style={{ maxWidth: '100%', maxHeight: '80vh' }}
                    />
                </Modal>
            )}
        </Modal>
    )
}
